import React, { useState } from "react";
import Beatloader from "../../../Common/Loaders/Beatloader";
import BankReconciliationStatementImport from "./BankReconciliationStatementImport";
import BankReconciliationProcessing from "./BankReconciliationProcessing";

const BankReconciliation = () => {
  const [activeTab, setActiveTab] = useState("statement_import");
  const [pageLoader, setPageLoader] = useState(false);

  const TabButton = ({ id, label }) => (
    <button
      className={`btn mx-1 px-4 py-2 rounded-pill ${
        activeTab === id
          ? "btn-light shadow-sm border"
          : "btn-outline-light text-muted border"
      }`}
      style={{
        background: activeTab === id ? "#ffffff" : "#f5f5f5",
        borderColor: "#e4e4e4",
      }}
      onClick={() => setActiveTab(id)}
    >
      {label}
    </button>
  );

  return (
    <>
      {pageLoader ? (
        <Beatloader />
      ) : (
        <div className="page-wrapper">
          <div className="content">
            {/* Tabs */}
            <div className="d-flex flex-wrap align-items-center mb-4 gap-2">
              <TabButton id="statement_import" label="Statement Import" />
              <TabButton
                id="bank_reconciliation_procesing"
                label="Bank Reconciliation Processing"
              />
            </div>

            <div className="p-4">
              {/* rcm_note */}
              {activeTab === "statement_import" && (
                <BankReconciliationStatementImport />
              )}

              {/* credit_note */}
              {activeTab === "bank_reconciliation_procesing" && (
                <BankReconciliationProcessing />
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default BankReconciliation;
